/* Лестница целей (ТЗ 5.9).

   Цель бывает двух видов:
     balance — сколько денег лежит на выбранных счетах (счета не выбраны — на всех);
     income  — сколько зарабатываем в месяц. Берём ту же цифру, что и кэшфлоу обзора:
               средний приход за последние три месяца.

   Цели идут по порядку: пока предыдущая не закрыта, следующая ждёт своей очереди.
   Прогресс у неё всё равно считается — видно, что она уже подрастает, но лестница
   до неё не дошла. */

import { toneColor } from "./constants.js";
import { accountsTotal } from "./finance.js";

export const GOAL_KINDS = [
  { id: "balance", label: "Деньги на счетах" },
  { id: "income", label: "Доход в месяц" },
];

/** Цвет цели: выбранный руками либо акцент интерфейса */
export const GOAL_COLOR = "#4a5ec6";
export const goalColor = (goal) => toneColor(goal?.color) || GOAL_COLOR;

/** Сколько по цели уже набрано */
export function goalCurrent(goal, { accounts = [], avgInflow = 0 } = {}) {
  if (goal?.kind === "income") return avgInflow;
  const ids = goal?.accounts || [];
  return accountsTotal(ids.length ? accounts.filter((a) => ids.includes(a.id)) : accounts);
}

/** Место в лестнице; при одинаковом — по номеру записи */
export const byLadder = (a, b) => (a.sortOrder ?? 100) - (b.sortOrder ?? 100) || a.id - b.id;

/** Лестница целей: прогресс и состояние каждой.
    done — закрыта, active — та, к которой идём сейчас, locked — ещё не стартовала.
    Закрытыми считаем только цели подряд от начала: сумма третьей могла набраться
    сама собой, но пока не закрыта первая, до третьей очередь не дошла. */
export function goalLadder(goals, ctx = {}) {
  let blocked = false;
  return [...(goals || [])].sort(byLadder).map((g, i) => {
    const current = goalCurrent(g, ctx);
    const target = g.goal || 0;
    const reached = target > 0 && current >= target;
    let state = "locked";
    if (!blocked) {
      state = reached ? "done" : "active";
      blocked = !reached;
    }
    const t = target ? Math.max(0, Math.min(1, current / target)) : 0;
    return { ...g, step: i + 1, current, state, t, pct: Math.round(t * 100) };
  });
}

/** Цель по доходу, к которой идём сейчас — от неё считается кэшфлоу обзора.
    Все закрыты — держим планку последней, чтобы шкала не осталась без цели. */
export const activeIncomeGoal = (ladder) => {
  const income = (ladder || []).filter((g) => g.kind === "income");
  return income.find((g) => g.state !== "done") || income[income.length - 1] || null;
};
